<template>
  <div class="vp-timezone-select">
    <VPCombobox
      input-id="timezone"
      :options="dropdownOptions"
      label="Select a Timezone"
      :clearable="true"
      placeholder="Select a timezone"
      @change="updateTimezone"
    />
  </div>
</template>

<script setup lang="ts">
import { defineProps, defineEmits } from 'vue';
import timezones from 'timezones-list';
import VPCombobox from '@/components/form/VPCombobox.vue';

defineProps({
  value: {
    type: String,
    required: true,
  },
});

const emit = defineEmits<{
  (e: 'change', value: string): void;
}>();

const dropdownOptions = timezones.map(zone => ({
  value: zone.tzCode,
  name: zone.name,
}));

const updateTimezone = (newZone?: unknown) => {
  if (typeof newZone === 'string') {
    emit('change', newZone);
  }
};
</script>
